// extracted by mini-css-extract-plugin
export default {"categoryChip":"CategoryChips_categoryChip__P6OEa","closeIcon":"CategoryChips_closeIcon__2vNXC"};